/*eslint no-unused-vars: ["error", { "args": "none" }]*/

import { SET_NAV_HEIGHT } from "../types";

export default {
  state: {
    height: 74,
  },
  getters: {},
  mutations: {
    [SET_NAV_HEIGHT]: (state, payload) => {
      state.height = payload;
    },
  },
  actions: {},
};
